import { FileReader, FileWriter } from '@/platform'

enum typeF {
    Mall = 1, // 素材库
    CloudDisk = 2, // 云网盘
}

class FileName {
    static typeF = typeF
    static DEF_TYPE = typeF.CloudDisk
    public type: typeF = typeF.Mall
    public name: string = ''

    constructor(param?: { type: typeF; name: string } | FileReader) {
        if (param && 'type' in param) {
            const { type, name } = param
            this.type = type
            this.name = name
        } else if (param instanceof FileReader) {
            this.readBin(param as FileReader)
        } else {
            this.type = typeF.Mall
        }
    }

    readBin(reader: FileReader): void {
        this.type = reader.readInt()
        this.name = reader.readString()
    }

    writeBin(writer: FileWriter): void {
        writer.writeInt(this.type)
        writer.writeString(this.name)
    }

    readVersionedOui(reader: FileReader): void {
        this.type = reader.readInt()
        this.name = reader.readString()
    }

    writeVersionedOui(writer: FileWriter): void {
        writer.writerIntLength()
        writer.writeInt(this.type)
        writer.writeString(this.name)
        writer.writerLength()
    }

    writeMallBin(writer: FileWriter): void {
        this.writeVersionedOui(writer)
    }
}

export default FileName
